"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Handles debouncing.
 */
var DebounceManager = /** @class */ (function () {
    function DebounceManager() {
        this.debounces = {};
    }
    /**
     * Sets a debounce.
     *
     * @param name Name.
     * @param callback Callback.
     * @param timeout Timeout.
     */
    DebounceManager.prototype.set = function (name, callback, timeout) {
        if (timeout === void 0) { timeout = 0; }
        this.clear(name);
        this.debounces[name] = window.setTimeout(callback, timeout);
    };
    /**
     * Checks if a debounce exists.
     *
     * @param name Name of debounce.
     * @returns TRUE if debounce exists.
     */
    DebounceManager.prototype.exists = function (name) {
        return typeof this.debounces[name] !== 'undefined';
    };
    /**
     * Clears a debounce.
     *
     * @param name Name of debounce.
     */
    DebounceManager.prototype.clear = function (name) {
        clearTimeout(this.debounces[name]);
        delete this.debounces[name];
    };
    /**
     * Clears all debounces.
     */
    DebounceManager.prototype.clearAll = function () {
        for (var _i = 0, _a = Object.keys(this.debounces); _i < _a.length; _i++) {
            var name_1 = _a[_i];
            this.clear(name_1);
        }
    };
    return DebounceManager;
}());
exports.default = DebounceManager;
//# sourceMappingURL=DebounceManager.js.map